import { render } from "./PaymentAllocationsView.vue?vue&type=template&id=22e4f315"
import script from "./PaymentAllocationsView.vue?vue&type=script&lang=js"
export * from "./PaymentAllocationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__